import styled from '@emotion/styled'
import { breakpoint, calcRem, metrics } from '../../__styling'
import { tokens } from '@news-mono/design-tokens'

const { white, neutral, starlight } = tokens.thenightly.colors.palette
const { md, m2l, lg, xxl, xxxxl } = metrics.thenightly.margins

export const StyledSettingScreen = styled.div<{ show?: boolean }>(
    ({ show }) => ({
        display: show ? 'block' : 'none',
        flex: 1,
        minWidth: calcRem(268),
        padding: calcRem(xxl, 0),

        h2: {
            fontSize: calcRem(40),
            fontWeight: 700,
            lineHeight: calcRem(48),
            color: neutral[100],
            marginTop: 0,
            marginBottom: calcRem(m2l),
        },

        h3: {
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            margin: calcRem(0, 0, md),
        },

        [breakpoint('sm')]: {
            display: 'block',
            borderRight: `0.5px solid ${neutral[20]}`,
            padding: calcRem(64, lg, xxl, 0),
            h2: {
                display: 'none',
            },
        },

        [breakpoint('lg')]: {
            padding: calcRem(xxxxl, lg, xxxxl, 0),
        },
    }),
)

export const StyledSettingHeader = styled.ul({
    listStyle: 'none',
    padding: calcRem(0, 0, 24, 0),
    margin: 0,
    borderBottom: `0.5px solid ${neutral[20]}`,

    li: {
        overflow: 'hidden',
    },

    'li:not(:last-child)': {
        marginBottom: calcRem(md),
    },

    h3: {
        marginBottom: calcRem(md),
    },

    small: {
        color: neutral[70],
        fontSize: calcRem(12),
        lineHeight: calcRem(16),
        fontWeight: 400,
    },

    p: {
        margin: 0,
        lineHeight: '150%',
        fontWeight: 400,
        fontSize: calcRem(16),

        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
})

export const StyledSettingBody = styled.ul({
    listStyle: 'none',
    margin: 0,
    padding: calcRem(m2l, 0, 0, 0),

    p: {
        margin: 0,
    },
})

export const StyledSettingOption = styled.li<{ isActive?: boolean }>(
    ({ isActive }) => ({
        marginBottom: calcRem(lg),
        color: neutral[70],
        span: {
            display: 'block',
            textTransform: 'uppercase',
            fontSize: calcRem(12),
            fontWeight: 600,
            lineHeight: calcRem(16),
            marginBottom: calcRem(16),
        },
        div: {
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            padding: calcRem(6, 24, 6, 16),
            borderRadius: '8px',
        },
        svg: {
            height: calcRem(m2l),
            width: calcRem(m2l),
        },
        p: {
            fontSize: calcRem(20),
            fontWeight: 400,
            lineHeight: calcRem(24),
        },
        [breakpoint('sm')]: {
            div: {
                background: isActive ? neutral[10] : white,
            },
            svg: {
                display: 'none',
            },
        },
    }),
)
